/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 我的下载
 */
import { EnumAPI } from '../../apis';
import { BaseModel, BasesController } from '../bases';
export class DownloadController<T = any> extends BasesController<T> {
    constructor() {
        super();
        this.reset({
            dataKey: 'id',
            infinite: true,
            pagination: EnumAPI.cert_down_list,
            paginationParams: {
                currentKey: 'pageNum',
                pageSizeKey: 'pageSize',
                response: {
                    dataSource: 'data',
                    total: 'total'
                }
            },
        })
    }
 
     
     
     /**
      * 值存储
      * @memberof DownloadController
      */
     Model = new BaseModel({ type: 'object' })
     
 }
 